import { getParamFromSearchOrHash } from '@shared/core';
import {
    getLoginUrl,
    getRetailTokenFromMemory,
    getRetailTokenFromStorage,
    getTargetSectionFromState,
    isCsrfFeatureEnabled,
    prepareState,
} from '@retail/core';
import { setCookie } from '@luna/cookies';
import { getEnv } from '@luna/env';
import { unsafeNavigate } from '@luna/router';
import { uuid } from '@luna/utils';

import { TPPFallbackHandler } from './TPPFallbackHandler';

export function isFirstPageInGeorge(): boolean {
    return !getRetailTokenFromStorage() || !getRetailTokenFromMemory();
}

export function isRedirectFromFedLoginOrSales(): boolean {
    return document.location.href.toLowerCase().includes('#access_token=');
}

export function handleFirstPage(): void {
    const tppHandler = new TPPFallbackHandler(getEnv(), window.location);
    tppHandler.handleTPPLoginRedirect();

    const state = getParamFromSearchOrHash('state') as string;
    let targetState = getTargetSectionFromState(state);

    if (targetState === '') {
        targetState = encodeURIComponent(document.location.hash.substring(1));
    }

    if (isCsrfFeatureEnabled()) {
        const newCsrfToken = uuid();
        setCookie('gt_csrf', newCsrfToken);

        targetState = prepareState(targetState, newCsrfToken);
    }

    document.location.href = getLoginUrl(getEnv(), targetState);
}

export function handleStateParam(): void {
    let state = getParamFromSearchOrHash('state');

    if (state && state.indexOf('handover/') > -1) {
        const frags = state.split('/');
        // eslint-disable-next-line @typescript-eslint/no-magic-numbers
        state = frags.slice(2, frags.length).join('/');
    }

    if (state) {
        unsafeNavigate(state);
    }
}
